import React from "react";
import { useState, useEffect } from "react";
import Dropdown from "olive-react-myoneui/lib/Dropdown";
import { calendarModuleName } from '../../../constants/config';
import { useTranslation } from 'react-i18next';
// The forwardRef is important!!
// Dropdown needs access to the DOM node in order to position the Menu
const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <div
    role="button"
    tabIndex={0}
    ref={ref}
    className="btn leading-icon text-primary"
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    {children}
  </div>
));

// forwardRef again here!
// Dropdown needs access to the DOM of the Menu to measure it
const CustomMenu = React.forwardRef(
  ({ children, style, className, "aria-labelledby": labeledBy }, ref) => {
    const [value, setValue] = useState("");

    return (
      <div
        ref={ref}
        style={style}
        className={className}
        aria-labelledby={labeledBy}
      >
        <ul className="list-unstyled mb-0">
          {React.Children.toArray(children).filter(
            (child) =>
              !value || child.props.children.toLowerCase().startsWith(value)
          )}
        </ul>
      </div>
    );
  }
);

function WeekDropdown({ mode, onChange = () => {} }) {
  const [value, setValue] = useState(mode);

  useEffect(() => {
    setValue(mode);
  }, [mode]);

  const onSelect = (index) => {
    setValue(index);
    onChange(index);
  };
  const { t } = useTranslation(calendarModuleName);
  return (
    <Dropdown
      className="dropdown-select text-end"
      align="end"
      onSelect={onSelect}
    >
      <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
        {mode.toUpperCase()}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="9.718"
          height="4.631"
          viewBox="0 0 9.718 4.631"
        >
          <path
            id="Path_40581"
            data-name="Path 40581"
            d="M7.756,2.95,3.879,0,0,2.95"
            transform="translate(8.737 3.931) rotate(180)"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.4"
          />
        </svg>
      </Dropdown.Toggle>
      <Dropdown.Menu
        value={value}
        as={CustomMenu}
        className="dropdown-menu w-dropdown-sm"
      >
        <Dropdown.Item eventKey="week" active={value === "week"}>
          <span className="px-2">{t('week')}</span>
        </Dropdown.Item>
        <Dropdown.Item eventKey="month" active={value === "month"}>
          <span className="px-2">{t('month')}</span>
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default WeekDropdown;
